import { defineMessages } from 'react-intl';
export default defineMessages({
  bookisSelected: {
    id: 'book.isSelected',
    defaultMessage: '选好啦',
  },
  booktopping: {
    id: 'book.topping',
    defaultMessage: '配料',
  },
  bookmenuInfo: {
    id: 'book.menuInfo',
    defaultMessage: '菜单信息',
  },
  booktotalCount: {
    id: 'book.totalCount',
    defaultMessage: '共{totalNum}份',
  },
  booktotal: {
    id: 'book.total',
    defaultMessage: '总计：',
  },
  bookPs: {
    id: 'book.Ps',
    defaultMessage: '备注',
  },
  booknoPs: {
    id: 'book.noPs',
    defaultMessage: '无备注',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/book/index.js